import { useState } from "react"

export const useCounter = (initialState = 10) => {
    const [state, setstate] = useState(initialState);

    const increment = (factor = 1) => {
    
        setstate( state + factor);
    }

    const decrement = (factor = 1) => {
        if(state > 0 ) {
            setstate( state - factor);
        }
    }

    const reset = () =>{
        setstate( initialState );
    }

    const setval = (val)=>{
        setstate(val)
    }

    return {
        state, increment, decrement, setval, reset
    }
}
